(function () {
/* eslint-disable import/no-unresolved */ /**
 * Global block styling and WordPress overrides.
 */ 
var $af3bed4d01cada7a$exports = {};
$af3bed4d01cada7a$exports = {};


var $827e940d3f98e59d$exports = {};















$827e940d3f98e59d$exports = {
    "about": {
        "about-": {}
    },
    "blog-article": {
        "blog-article-": {}
    },
    "chef-info": {
        "chef-info-": {}
    },
    "contact-cta": {
        "contact-cta-": {}
    },
    "events": {
        "events-": {}
    },
    "executive-chef": {
        "executive-chef-": {}
    },
    "gallery-cta": {
        "gallery-cta-": {}
    },
    "hero": {
        "hero-": {}
    },
    "media-hero": {
        "media-hero-": {}
    },
    "menu-inspiration": {
        "menu-inspiration-": {}
    },
    "partners": {
        "partners-": {}
    },
    "post-template": {
        "post-template-": {}
    },
    "section-header": {
        "section-header-": {}
    },
    "team": {
        "team-": {}
    },
    "whos-cooking": {
        "whos-cooking-": {}
    }
};


var $1528de3b5c5ab8d9$exports = {};
var $640ea83c9f44339f$exports = {};
/**
 * Ani JavaScript
 *
 * This file defines behaviors of
 * ani blocks.
 */ // import animations
/**
 * Scroll-Based Animations
 *
 * Animate elements fluidly based on scroll position.
 *
 * Examples:
 *  aniScroll('.ani--parallax');
 *  // or
 *  aniScroll(document.querySelectorAll('.ani--parallax'));
 *  // or
 *  aniScroll([
 *      document.querySelector('.ani--parallax'),
 *      document.querySelector('.ani--parallax-alt')
 *  ]);
 *  // or (bases animation on window height rather than total element height)
 *  aniScroll('.ani--parallax', false);
 *
 * @param  {mixed}    mixed        Wrapper element (as selector string, nodelist, or array of nodes)
 * @param  {boolean}  useElHeight  Stretch animations over full element height (true/default) or just window height (false)
 */ const $4a02d9a421878f6f$export$1a19be9ddcc0f28a = (mixed, useElHeight = true)=>{
    // identify scroll-based animation elements
    const isStr = typeof mixed === "string";
    const scrollWraps = isStr ? document.querySelectorAll(mixed) : mixed;
    // bail if we have nothing
    if (!scrollWraps.length) return;
    // prep to store all scroll-based animation elements
    const scrollable = {};
    // prep to store all all currently animating elements
    const scrollers = {};
    // animate things based on scroll position
    const animate = ()=>{
        // if we have elements that should animate (i.e. they're in the viewport)
        const keys = Object.keys(scrollers);
        if (keys.length) // animate each
        keys.forEach((key)=>{
            const item = scrollers[key];
            const win = window.innerHeight;
            const { top: top, height: height } = item.getBoundingClientRect();
            const stretch = useElHeight ? height : 0;
            let per = (top + stretch) / (win + stretch);
            // don't go out of bounds (allow 0 min and 1 max)
            if (per < 0) per = 0;
            else if (per > 1) per = 1;
            scrollers[key].style.setProperty("--ani-plx", per);
        });
    };
    // create an observer so we can animate elements only when in view
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            // get the ID of this entry
            const id = entry.target.dataset.aniScroll;
            // if in view add to currently animating and identify as shown
            if (entry.isIntersecting) {
                scrollers[id] = scrollable[id];
                scrollable[id].classList.add("is-shown");
            // if not in view remove shown and delete from currently animating
            } else {
                scrollable[id].classList.remove("is-shown");
                delete scrollers[id];
            }
        });
    }, {
        rootMargin: "10px 0px 10px"
    });
    // controll scroll-based animations (throttled)
    let timer;
    window.addEventListener("scroll", ()=>{
        window.cancelAnimationFrame(timer);
        timer = window.requestAnimationFrame(animate);
    });
    // initialize animations
    scrollWraps.forEach((el, index)=>{
        // create a unique id for this element
        const id = `el${index}`;
        el.dataset.aniScroll = id;
        // add this element to the list of scrollable things
        scrollable[id] = el;
        // add these to the observer so it can apply animations when they're in view
        observer.observe(el);
    });
    // trigger animations on initial script load
    animate();
    // reload on load to be certain image sizes e.g. are calculated
    window.addEventListener("load", animate);
    // reload on resize (debounced)
    let resizeTimer = null;
    window.addEventListener("resize", ()=>{
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(()=>{
            animate();
        }, 300);
    });
};


/**
 * Background Animations
 *
 * Full-screen, fixed-position background animations.
 *
 * @param {mixed} element Selector string, nodelist, or array of nodes.
 * @param {boolean} isPopupStyle Whether to block adjacent content like a popup on active.
 */ const $80fcf53d95ab6533$export$a77aa55c7ffce249 = (element, isPopupStyle = false)=>{
    const els = typeof element === "string" ? document.querySelectorAll(element) : element;
    if (els.length) {
        // watch intersection
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // if the element is shown
                const el = entry.target;
                if (entry.isIntersecting) {
                    el.classList.add("is-shown-bg");
                    if (el?.classTransfers) el.classTransfers.forEach((className)=>{
                        el.fixedBackground.classList.add(className);
                        el.classList.add(className);
                    });
                    el.fixedBackground.classList.add("active");
                } else {
                    el.classList.remove("is-shown-bg");
                    el.fixedBackground.classList.remove("active");
                    el.classList.remove(el.colorClassName);
                }
            });
        }, {
            rootMargin: "-50% 0% -50%"
        });
        // loop through our elements
        const torsoEl = document.querySelector(".torso");
        els.forEach((el)=>{
            // create the background feature and add it to the body (behind everything else)
            const fixedBackground = document.createElement("i");
            fixedBackground.setAttribute("aria-hidden", true);
            fixedBackground.classList.add("background-color-block", `background-color-block--${isPopupStyle ? "foreground" : "background"}`);
            const coverEls = el.querySelectorAll(".wp-block-cover__gradient-background, .wp-block-cover__video-background, .wp-block-cover__image-background, .wp-block-cover__background");
            if (coverEls.length) {
                fixedBackground.classList.add("wp-block-cover");
                coverEls.forEach((childEl)=>fixedBackground.appendChild(childEl));
            }
            torsoEl.appendChild(fixedBackground);
            el.fixedBackground = fixedBackground;
            // determine what classes to add/remove
            const classNames = [
                ...el.classList
            ];
            const classTransfers = classNames.filter((className)=>/^has-.*-background-color$/.test(className) || /^is-style-.*$/.test(className));
            if (classTransfers.length) el.classTransfers = classTransfers;
            // wait to remove background till things are loaded
            if (el.tagName.toLowerCase() === "header") onReady(()=>{
                // wait till bg animations finish
                setTimeout(()=>{
                    el.classList.add("is-loaded");
                }, 1000);
            });
            // attach the observer to the animated elements
            observer.observe(el);
        });
    }
};


/**
 * Viewport-Based Animations
 *
 * Run an animation on elements once they enter the viewport.
 *
 * @param {nodelist}} els Elements to which we'll attach animations
 */ const $f89350c3b6e93bc2$export$54f1b784138e2127 = (els)=>{
    // if we have elements
    if (els.length) {
        // set up an observer
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // toggle .is-shown based on visibility in viewport
                entry.target.classList.toggle("is-shown", entry.isIntersecting);
            });
        }, {
            rootMargin: "10px 0px 0px"
        });
        // add all elements to the observer
        els.forEach((el)=>{
            observer.observe(el);
        });
    }
};
const $f89350c3b6e93bc2$export$f8bf712d50738e = (delegatedSelectors, aniClassName = "ani")=>{
    const allAniEls = [];
    // for every parent/child pair
    delegatedSelectors.forEach(({ parent: parentSelector, child: childSelector })=>{
        // for every parent element
        document.querySelectorAll(parentSelector)?.forEach((parentEl)=>{
            // get all the children we're to delegate to
            const childEls = parentEl.querySelectorAll(childSelector);
            // if we have children to delegate to
            if (childEls.length) {
                // get the parent's ani classes
                const aniClassNames = [
                    aniClassName,
                    ...[
                        ...parentEl.classList
                    ].filter((className)=>className.substr(0, 5) === `${aniClassName}--`)
                ];
                // for every child we're delegating to
                childEls?.forEach((childEl, i)=>{
                    // add ani classes
                    childEl.classList.add(...aniClassNames);
                    // stagger animations slightly
                    childEl.style.setProperty("--ani-delay-increment", i);
                    // add this child to the animation list
                    allAniEls.push(childEl);
                });
                // remove ani classes from the parent
                parentEl.classList.remove(...aniClassNames);
            } else if (parentEl.classList.contains(aniClassName)) // add parent to animation list (if has ani class and no delegates)
            allAniEls.push(parentEl);
        });
    });
    return allAniEls;
};
const $f89350c3b6e93bc2$export$2eb69c0aa2ecf141 = (element, aniClassNameList = [
    "ani"
])=>{
    const els = typeof element === "string" ? document.querySelectorAll(element) : element;
    if (els.length) els.forEach((el)=>{
        // remove other animation types (like viewport-based animations)
        el.classList.remove(...aniClassNameList);
        // if this is a loadable media element
        if (el.complete !== undefined) {
            if (el.complete) // show the element after a bit if it's already cached
            setTimeout(()=>{
                el.classList.add("is-shown");
            }, 100);
            else // show the element after it loads for the first time
            el.addEventListener("load", ()=>{
                el.classList.add("is-shown");
            });
        } else if ([
            "interactive",
            "complete"
        ].includes(document.readyState)) // show the element if the page is already ready
        el.classList.add("is-shown");
        else // show the element on page ready
        document.addEventListener("DOMContentLoaded", ()=>el.classList.add("is-shown"), false);
    });
};


// animate items once on page load
(0, $f89350c3b6e93bc2$export$2eb69c0aa2ecf141)(".ani--load");
// animate items on scroll (scrubs animation as you scroll)
(0, $4a02d9a421878f6f$export$1a19be9ddcc0f28a)(".ani--parallax", true);
// animate background colors and media (like background-attachment:fixed)
(0, $80fcf53d95ab6533$export$a77aa55c7ffce249)(".ani--background");
// animate foreground colors and media (like position:fixed popup)
(0, $80fcf53d95ab6533$export$a77aa55c7ffce249)(".ani--foreground", true);
// (must come last as items above remove some extra .ani classes)
// animate items when they enter the viewport
(0, $f89350c3b6e93bc2$export$54f1b784138e2127)([
    // delegate some animations (i.e. Gutenberg applies classes to parent and we'll move them to an appropriate child)
    ...(0, $f89350c3b6e93bc2$export$f8bf712d50738e)([
        {
            parent: ".ani-parent",
            child: ".ani-child"
        },
        // eslint-disable-next-line prettier/prettier
        {
            parent: ".wp-block-cover:not(.ani--parallax)",
            child: ".wp-block-cover__image-background"
        },
        {
            parent: ".wp-block-columns",
            child: ".wp-block-column"
        },
        {
            parent: ".wp-block-buttons",
            child: ".wp-block-button"
        }
    ]),
    // must come second so aniDelegate can move .ani class to children and off of the parent
    ...document.querySelectorAll(".ani")
]);


$1528de3b5c5ab8d9$exports = {
    "ani": {
        "ani-": $640ea83c9f44339f$exports
    }
};


var $0fdcea96c0d01a34$exports = {};





$0fdcea96c0d01a34$exports = {
    "ani": {
        "ani-": {}
    },
    "button": {
        "button-": {}
    },
    "column": {
        "column-": {}
    },
    "quote": {
        "quote-": {}
    },
    "show-hide": {
        "show-hide-": {}
    }
};



})();
//# sourceMappingURL=blocks.bundle.js.map
